import React from "react";
import { useSelector } from "react-redux";

const UpdateAppPopup = ({ updateAppVersion }) => {
  const {
    adminData: { headerLinks },
  } = useSelector((state) => state.support);
  const name =
    headerLinks?.appName?.clientSpecificLabel ||
    headerLinks?.appName?.defaultLabel;

  return (
    <div className="update-app-popup">
      <div className="popup-content">
        <h1 className="text-center">Update Available</h1>
        <p>
          We are always working to improve {name} and are committed to providing
          you with the best possible user experience.
          <br />
          <br />
          Please click the "UPDATE" button below to access {name}.
        </p>
        <button
          onClick={() => updateAppVersion(true)}
          className="update-button btn-primary text-center wide"
        >
          Update
        </button>
      </div>
    </div>
  );
};

export default UpdateAppPopup;
